// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SocialTwitter: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fillRule="evenodd" d="M37.1 17.3c-.9.4-1.8.7-2.7.8 1-.6 1.7-1.6 2.1-2.8-.9.6-1.9 1-3 1.2-.9-1-2.1-1.6-3.5-1.6-2.6 0-4.8 2.3-4.8 5.1 0 .4 0 .8.1 1.2-3.9-.2-7.4-2.2-9.8-5.3-.4.8-.6 1.6-.6 2.6 0 1.8.8 3.3 2.1 4.3-.8 0-1.5-.2-2.2-.6v.1c0 2.5 1.6 4.5 3.8 5-.4.1-.8.2-1.3.2-.3 0-.6 0-.9-.1.6 2 2.4 3.5 4.4 3.6-1.6 1.4-3.7 2.2-5.9 2.2-.4 0-.8 0-1.1-.1 2.1 1.5 4.6 2.3 7.3 2.3 8.7 0 13.5-7.8 13.5-14.6v-.7c1-.9 1.8-1.8 2.5-2.8" clipRule="evenodd"/></svg>;
};

export default React.memo(SocialTwitter);
